<div class="transparent-loader" *ngIf='isLoading || checkoutService.loading.value || cartService.loading.value'>
	<loader></loader>
</div>

<div class="empty_space"></div>

<div class="container">
	<ng-container *ngIf='methodsPaymentEnabled'>
		<div class="row" *ngIf='!cartService.loading.value && cartData && cartData.num_items;'>
			<div class="col-xl-7 col-lg-7 col-md-12">
				<form [formGroup]='formGroup' (ngSubmit)='onSubmit()'>
					<legend class="header detail-header smaller-bottom-margin">{{'Dettagli del pagamento' | translate}}</legend>
					<div class="required-fields"><span class="required">*</span> {{'Campi obbligatori' | translate}}</div>

					<!-- entity data -->
					<fieldset class="checkout-section checkout-section-details">
						<div class="form-row">
							<label for="billing_prename">{{'Nome' | translate}} <span class="required">*</span></label>
							<input type="text" formControlName='name' id="billing_prename" class="form-control show-positive-feedback" />
							<ng-container *ngIf='(formGroup.controls["name"].dirty || formGroup.controls["name"].touched) && formGroup.controls["name"].invalid && formGroup.controls["name"].errors.required'>
								<span class="error-msg">{{'Inserisci un nome che sia valido.' | translate}}</span>
							</ng-container>
						</div>

						<div class="form-row">
							<label for="billing_surname">{{'Cognome' | translate}} <span class="required">*</span></label>
							<input type="text" formControlName='surname' id="billing_surname" class="form-control show-positive-feedback" />
							<ng-container *ngIf='(formGroup.controls["surname"].dirty || formGroup.controls["surname"].touched) && formGroup.controls["surname"].invalid && formGroup.controls["surname"].errors.required'>
								<span class="error-msg">{{'Inserisci un cognome che sia valido.' | translate}}</span>
							</ng-container>
						</div>

						<div class="form-row">
							<label for="billing_email">{{'Email' | translate}} <span class="required">*</span></label>
							<input type="text" formControlName='email' id="billing_email" class="form-control show-positive-feedback" />
							<ng-container *ngIf='(formGroup.controls["email"].dirty || formGroup.controls["email"].touched) && formGroup.controls["email"].invalid && formGroup.controls["email"].errors.required'>
								<span class="error-msg">{{'Inserisci una mail valida.' | translate}}</span>
							</ng-container>
							<ng-container *ngIf='(formGroup.controls["email"].dirty || formGroup.controls["email"].touched) && formGroup.controls["email"].invalid && formGroup.controls["email"].errors.email'>
								<span class="error-msg">{{'La mail inserita non è valida.' | translate}}</span>
							</ng-container>
						</div>

						<div class="form-row">
							<label for="billing_country">{{'Paese' | translate}} <span class="required">*</span></label>
							<select formControlName='country' id="billing_country" class="form-control show-positive-feedback">
								<ng-container *ngFor='let country of countries'>
									<option [value]='country.code'>{{country.description}}</option>
								</ng-container>
							</select>
							<span class='fa fa-spinner fa-spin nation-spinner' *ngIf='loadingCountries'></span>
							<ng-container *ngIf='(formGroup.controls["country"].dirty || formGroup.controls["country"].touched) && formGroup.controls["country"].invalid && formGroup.controls["country"].errors.required'>
								<span class="error-msg">{{'Seleziona un paese.' | translate}}</span>
							</ng-container>
						</div>

						<div class="form-row">
							<label for="billing_tel">{{'Tel' | translate}} <span class="required">*</span></label>
							<input type="text" formControlName='tel' id="billing_tel" class="form-control show-positive-feedback" />
							<ng-container *ngIf='(formGroup.controls["tel"].dirty || formGroup.controls["tel"].touched) && formGroup.controls["tel"].invalid && formGroup.controls["tel"].errors.required'>
								<span class="error-msg">{{'Inserisci un numero di tel. valido.' | translate}}</span>
							</ng-container>
						</div>

						<!-- passengere details -->
						<div class="form-row ticket_details">
							<h5>{{'Dettaglio passeggeri (dettaglio biglietti)' | translate}}</h5>
							<label><input type="checkbox" formControlName='passengers_details' (change)='ticketDetails($event)' /> {{'Come da indirizzo di fatturazione' | translate}}</label>
						</div>

						<div [formArrayName]='"participants"'>
							<ng-container *ngIf='ticket_details'>
								<ng-container *ngFor='let participantGroup of formGroup.get("participants")["controls"]; let i = index;'>
									<h5>{{cartData.cart_items[i].target_info.display_name_item}}</h5>
									<ng-container *ngFor='let element of ["ADT", "CHD", "INF", "SNR"]'>
										<ng-container *ngIf='participantGroup.controls[cartData.cart_items[i].trip_booking_id].get(element)'>
											<ng-container *ngFor='let participantFormGroup of participantGroup.controls[cartData.cart_items[i].trip_booking_id].get(element)["controls"]; let j = index;'>
												<h5>{{'Dati partecipante' | translate}} {{j + 1}}</h5>
												<div [formGroup]='participantFormGroup'>
													<div class="form-row">
														<label>{{'Nome' | translate}} <span class="required">*</span></label>
														<input type="text" formControlName='name' class="form-control show-positive-feedback" />
														<ng-container *ngIf='(participantFormGroup.controls["name"].dirty || participantFormGroup.controls["name"].touched) && participantFormGroup.controls["name"].invalid && participantFormGroup.controls["name"].errors.required'>
															<span class="error-msg">{{'Inserisci nome partecipante.' | translate}}</span>
														</ng-container>
													</div>

													<div class="form-row">
														<label>{{'Cognome' | translate}} <span class="required">*</span></label>
														<input type="text" formControlName='surname' class="form-control show-positive-feedback" />
														<ng-container *ngIf='(participantFormGroup.controls["surname"].dirty || participantFormGroup.controls["surname"].touched) && participantFormGroup.controls["surname"].invalid && participantFormGroup.controls["surname"].errors.required'>
															<span class="error-msg">{{'Inserisci cognome partecipante.' | translate}}</span>
														</ng-container>
													</div>

													<div class="form-row">
														<label>{{'Email' | translate}} <span class="required">*</span></label>
														<input type="text" formControlName='email' class="form-control show-positive-feedback" />
														<ng-container *ngIf='(participantFormGroup.controls["email"].dirty || participantFormGroup.controls["email"].touched) && participantFormGroup.controls["email"].invalid && participantFormGroup.controls["email"].errors.required'>
															<span class="error-msg">{{'Inserisci email partecipante.' | translate}}</span>
														</ng-container>
													</div>

													<div class="form-row">
														<label>{{'Paese' | translate}} <span class="required">*</span></label>
														<select formControlName='country' class="form-control show-positive-feedback">
															<ng-container *ngFor='let country of countries'>
																<option [value]='country.code'>{{country.description}}</option>
															</ng-container>
														</select>
														<span class='fa fa-spinner fa-spin nation-spinner' *ngIf='loadingCountries'></span>
														<ng-container *ngIf='(participantFormGroup.controls["country"].dirty || participantFormGroup.controls["country"].touched) && participantFormGroup.controls["country"].invalid && participantFormGroup.controls["country"].errors.required'>
															<span class="error-msg">{{'Seleziona un paese.' | translate}}</span>
														</ng-container>
													</div>

													<div class="form-row">
														<label>{{'Tel' | translate}} <span class="required">*</span></label>
														<input type="text" formControlName='tel' class="form-control show-positive-feedback" />
													</div>
												</div>
											</ng-container>
										</ng-container>
									</ng-container>
								</ng-container>
							</ng-container>
						</div>
					</fieldset>

					<!-- select method payment -->
					<fieldset class="checkout-section checkout-selection-payment">
						<legend class="header payment-header border-top">{{'Seleziona il metodo di pagamento' | translate}}</legend>

						<div id="payment-selection-container" class="payment-selection-container">
							<div class="payment-options">
								<p class="payment-secure-message icon-lock"><i class="fa fa-lock"></i>&nbsp;{{'I pagamenti sono sicuri e criptati' | translate}}</p>

								<ul id="payment-selection" class="payment-selection">
									<!-- paypal -->
									<ng-container *ngIf='paypalConfig.enabled'>
										<div class="showNonDebitMethodsFirst">
											<li class="paypal available">
												<label for="p_s_paypal" class="payment-label">
													<input required type="radio" formControlName='p_s' value="paypal" id="p_s_paypal" />
													<span class="payment-method paypal"></span>
													<span class="method-expla">Paypal</span>
												</label>
												<div class="payment-method-next-steps active" *ngIf='payment_type.value === "paypal"'>
													<strong>{{'Ti reindirizzeremo alla pagina di PayPal per completare il pagamento.' | translate}}&nbsp;</strong>
													<span>{{'La conferma della prenotazione apparirà dopo aver effettuato il pagamento.' | translate}}</span>
												</div>
											</li>
										</div>
									</ng-container>
									<!-- stripe -->
									<ng-container *ngIf='stripeConfig.enabled'>
										<div class="showNonDebitMethodsFirst">
											<li class="stripe available">
												<label for="p_s_stripe" class="payment-label">
													<input required type="radio" formControlName='p_s' value="stripe" id="p_s_stripe" />
													<img src="assets/img/mastercard.svg" />
													<img src="assets/img/visa.svg" />
													<img src="assets/img/maestro.svg" />
													<span class="method-expla">{{'Carta di credito' | translate}}</span>
												</label>
												<div class="payment-method-next-steps active" *ngIf='payment_type.value === "stripe"'>
													<div #cardElement id="card-element" class="form-control">
														<span *ngIf='stripeIsLoading' class='fa fa-spinner fa-spin'></span>
														<!--Stripe.js injects the Card Element-->
													</div>
												</div>
												<p id="card-error" role="alert"></p>
											</li>
										</div>
									</ng-container>
								</ul>
							</div>
						</div>
					</fieldset>

					<!-- conditions -->
					<fieldset class="checkout-section checkout-conditions" formGroupName='conditions'>
						<legend class="header conditions-header border-none">{{'Condizioni di vendita' | translate}}</legend>

						<div>
							<label for="first">
								<input type="checkbox" id="first" formControlName='first' />
								{{'Ho letto e accetto l\'informativa inerente al trattamento dei dati personali *' | translate}}
							</label>
						</div>

						<div>
							<label for="second">
								<input type="checkbox" id="second" formControlName='second' />
								{{'Ho letto e accetto il trattamento dei miei dati a fini commerciali (opzionale)' | translate}}
							</label>
						</div>

						<div>
							<label for="third">
								<input type="checkbox" id="third" formControlName='third' />
								{{'Ho letto e accetto termini e condizioni le condizioni di vendita *' | translate}}
							</label>
						</div>
					</fieldset>

					<div class="form-row">
						<button #submitBtn [disabled]='!formGroup.valid || submitBtnDisabled' type="submit" class="btn btn-primary submit-btn btn-small btn-redeem">
							{{'Procedi al pagamento' | translate}}
						</button>
					</div>
				</form>
			</div>

			<div class="col-xl-5 col-lg-5 col-md-12">
				<div id="content-right" class="content-right sticky-sidepanel">
					<div class="checkout-order-summary-experiment review">
						<div id="total-price-container" class="total-price-container checkout-order-summary-experiment">
							<div class="cart-total-price">
								<div class="price-tag">
									<span class="label total">{{'Totale' | translate}} ({{cartData.num_items}} {{ (cartData.num_items > 1 ? 'articoli': 'articolo') | translate }})</span>
									<span class="price">
										<span class="total-price">{{cartData.total_cart | currency:'EUR'}}</span>
									</span>
									<p class="all-fees-included">{{'Nessuna tassa aggiuntiva' | translate}}</p>
								</div>
							</div>
						</div>

						<div class="white-container">
							<div class="cart-items-container">
								<ul class="cart-items cart">
									<ng-container *ngFor='let key of cartData.cart_items | customKeys; let isFirst = first;'>
										<!-- tempates rendering -->
										<ng-container [ngSwitch]='cartData.cart_items[key].target'>
											<ng-container
												*ngSwitchCase='"trip_packages"'
												[ngTemplateOutlet]='trip_packages_cart'
												[ngTemplateOutletContext]='{
													cartItem: cartData.cart_items[key],
													isFirst: isFirst
												}'
											></ng-container>
											<ng-container
												*ngSwitchCase='"product"'
												[ngTemplateOutlet]='product_cart'
												[ngTemplateOutletContext]='{
													cartItem: cartData.cart_items[key],
													isFirst: isFirst
												}'
											></ng-container>
											<div *ngSwitchDefault>Nessun template configurato</div>
										</ng-container>
									</ng-container>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="no-items" *ngIf='!cartService.loading.value && cartData && !cartData.num_items;'>
			<h2>{{'Pagamento' | translate}}</h2>
			<p>{{'Nessun elemento presente nel carrello. Non è possibile concludere l\'ordine.' | translate}}</p>
			<backtolist></backtolist>
		</div>
	</ng-container>

	<div *ngIf='!methodsPaymentEnabled && !appService.loading.value'>
		<ng-container *ngTemplateOutlet='nopayments'></ng-container>
	</div>
</div>

<ng-template #nopayments>
	<div class="no-payments">
		<h2>{{'Pagamento' | translate}}</h2>
		<p>{{'Nessun pagamento abilitato e configurato.' | translate}}</p>
		<backtolist></backtolist>
	</div>
</ng-template>

<ng-template #trip_packages_cart let-cartItem='cartItem' let-isFirst='isFirst'>
	<li [ngClass]="{'cart-item': true, 'is-booking': true, 'first-item': isFirst}">
		<div class="cart-item-booking addons-enabled">
			<div class="image-container">
				<a class="link" [routerLink]='["/d", appService.domainId, "products", cartItem.target_info.display_name_item | slugify, cartItem.trip_package_id]'>
					<img *ngIf='cartItem.target_info.master_image_item' [src]="this.appService.getBaseServerAddress() + '/document_files/resize/367x76/' + cartItem.target_info.master_image_item" />
					<img *ngIf='!cartItem.target_info.master_image_item' src="assets/img/367x76.png" />
				</a>
			</div>
		</div>

		<div class="content-container">
			<div class="details">
				<header class="tour-title">
					<h3 class="title">
						<a class="link" [routerLink]="['/d', appService.domainId, 'detail', 'trip_packages', cartItem.trip_package_id]">
							{{cartItem.target_info.display_name_item}}
						</a>
					</h3>
				</header>

				<div class="details-list">
                    <div class="participants" *ngIf="cartItem.target_info.is_family">
           <span class="adt" *ngIf='cartItem.trip_booking.participant_counters["ADT"]'>
				  BIGLIETTO FAMIGLIA
			</span>
                    </div>
					<div class="participants">

						<span class="adt" *ngIf='cartItem.trip_booking.participant_counters["ADT"]'>
							{{ cartItem.trip_booking.participant_counters["ADT"] }} X ADT
						</span>
						<span class="chd" *ngIf='cartItem.trip_booking.participant_counters["CHD"]'>
							{{ cartItem.trip_booking.participant_counters["CHD"] }} X CHD
						</span>
						<span class="inf" *ngIf='cartItem.trip_booking.participant_counters["INF"]'>
							{{ cartItem.trip_booking.participant_counters["INF"] }} X INF
						</span>
						<span class="snr" *ngIf='cartItem.trip_booking.participant_counters["SNR"]'>
							{{ cartItem.trip_booking.participant_counters["SNR"] }} X SNR
						</span>
					</div>

					<div class="tour-date">{{ cartItem.date | date: 'dd/MM/yyyy' }}</div>
					<div class="item-name">{{ cartItem.target_info.variation_name_item }}</div>

					<div class="prices-item">
						<div class='item-price'>
							{{ cartItem.trip_booking.total_amount | currency:'EUR' }}
						</div>
					</div>
				</div>
			</div>
		</div>
	</li>
</ng-template>

<ng-template #product_cart let-cartItem='cartItem' let-isFirst='isFirst'>
	<li [ngClass]="{'cart-item': true, 'is-booking': true, 'first-item': isFirst}">
		<div class="cart-item-booking addons-enabled">
			<div class="image-container">
				<a class="link" [routerLink]='["/d", appService.domainId, "products", cartItem.target_info.display_name_item | slugify, cartItem.trip_package_id]'>
					<img *ngIf='cartItem.target_info.master_image_item' [src]="this.appService.getBaseServerAddress() + '/document_files/resize/367x76/' + cartItem.target_info.master_image_item" />
					<img *ngIf='!cartItem.target_info.master_image_item' src="assets/img/367x76.png" />
				</a>
			</div>
		</div>

		<div class="content-container">
			<div class="details">
				<header class="tour-title">
					<h3 class="title">
						<a class="link" [routerLink]="['/d', appService.domainId, 'detail', 'products', cartItem.product_id]">
							{{cartItem.target_info.display_name_item}}
						</a>
					</h3>
				</header>

				<div class="details-list">
					<div class="participants">
						<span class="adt" *ngIf='cartItem.trip_booking.participant_counters["ADT"]'>
							{{'Quantità' | translate}} {{ cartItem.trip_booking.participant_counters["ADT"] }}
						</span>
					</div>

					<div class="tour-date">{{ cartItem.date | date: 'dd/MM/yyyy' }}</div>

					<div class="prices-item">
						<div class='item-price'>
							{{ cartItem.trip_booking.total_amount | currency:'EUR' }}
						</div>
					</div>
				</div>
			</div>
		</div>
	</li>
</ng-template>
